import { InjectionToken } from '@angular/core';

// import translations
import { LANG_EN_NAME, LANG_EN_TRANS } from './lang-en';
import { LANG_ES_NAME, LANG_ES_TRANS } from './lang-es';
import { LANG_IT_NAME, LANG_IT_TRANS } from './lang-it';
import { LANG_PT_NAME, LANG_PT_TRANS } from './lang-pt';
import { LANG_FN_NAME, LANG_FN_TRANS } from './lang-fn';

// translation token
export const TRANSLATIONS = new InjectionToken('translations');

// all translations
export const dictionary = {
    [LANG_EN_NAME]: LANG_EN_TRANS,
    [LANG_ES_NAME]: LANG_ES_TRANS,
    [LANG_IT_NAME]: LANG_IT_TRANS,
    [LANG_PT_NAME]: LANG_PT_TRANS,
    [LANG_FN_NAME]: LANG_FN_TRANS,
};

// providers
export const TRANSLATION_PROVIDERS = [
    { provide: TRANSLATIONS, useValue: dictionary },
];
